import React, { useState } from "react";
import {
  Text,
  Stack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Input,
  Button,
  Textarea,
  Box,
  ModalHeader,
} from "@chakra-ui/react";
import { isValidURL } from "../../utils/IsValidUrl";
import IsDesktop from "../../utils/IsDesktop";
import ConvertVideoLinkToEmbedLink from "../../utils/ConvertVideoLinkToEmbedLink";

export default function VideoPreviewModal({ 
  isOpen, 
  onClose, 
  videoLink,
}) {
  const isDesktop = IsDesktop();
  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
        <ModalHeader>Video</ModalHeader>
          <ModalBody p={4}>

          <Box className={`w-full lg:w-[80%] max-w-[1000px] mx-auto my-10`}>
                <Box>
                  {videoLink &&
                  isValidURL(videoLink) ? (
                    <object
                      data={ConvertVideoLinkToEmbedLink(videoLink)}
                      width="100%"
                      className={`${isDesktop ? 'min-h-[400px]' : 'min-h-[200px]'} border rounded-lg`}
                    >
                      <iframe
                        width="100%"
                        height="50%"
                        src={ConvertVideoLinkToEmbedLink(videoLink)}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </object>
                  ) : (
                    <Text color="text-gray-600 font-semibold p-3 text-center text-sm"></Text>
                  )}
                </Box>
              </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
